import {
  Page,
  useLazyGetOrganismeUtilisateursQuery,
  UtilisateurInscriptionDto,
  UtilisateurProjection,
  UtilisateurRole,
} from '@common/services';
import { groupBy } from '@common/utils';

export function useGetInscriptionUtilisateurs() {
  const [getOrganismeUtilisateurs] = useLazyGetOrganismeUtilisateursQuery();

  return {
    getInscriptionUtilisateurs: async (organismeId: number) => {
      const pageUtilisateurs: Page<UtilisateurInscriptionDto> = await getOrganismeUtilisateurs({
        id: organismeId,
        projection: UtilisateurProjection.INSCRIPTION,
        page: 0,
        size: 4,
        filters: {
          role: [
            UtilisateurRole.ADMIN_1,
            UtilisateurRole.ADMIN_2,
            UtilisateurRole.REPRESENTANT,
            UtilisateurRole.DELEGATAIRE,
          ],
        },
      }).unwrap();

      const {
        ADMIN_1: admin1,
        ADMIN_2: admin2,
        REPRESENTANT: representant,
        DELEGATAIRE: delegataire,
      } = groupBy<UtilisateurRole, UtilisateurInscriptionDto>('role', pageUtilisateurs.content);

      return { admin1, admin2, representant, delegataire };
    },
  };
}